import { type QueryKey, skipToken, useQuery } from '@tanstack/react-query';
import isObject from 'lodash/isObject';

import { type ListSizeSettingSetsResponse, SizeSettings } from '@air/api';
import { callAirApi } from '@air/utils-api';

export const PRIVATE_SIZE_SETS_LIST_KEY = 'PRIVATE_SIZE_SETS_LIST';

export type PrivateSizeSetsListKey = [typeof PRIVATE_SIZE_SETS_LIST_KEY, UsePrivateSizeSetsListParams];

export const getPrivateSizeSetsListKey = (params: UsePrivateSizeSetsListParams): PrivateSizeSetsListKey => {
  return [PRIVATE_SIZE_SETS_LIST_KEY, params];
};

export const isPrivateSizeSetsListKey = (key: QueryKey): key is PrivateSizeSetsListKey => {
  return Array.isArray(key) && key[0] === PRIVATE_SIZE_SETS_LIST_KEY && isObject(key[1]);
};

export type UsePrivateSizeSetsListParams = {
  workspaceId: string | undefined;
};

export type UsePrivateSizeSetsListOptions = {
  enabled?: boolean;
  staleTime?: number;
};

export const usePrivateSizeSetsList = (
  params: UsePrivateSizeSetsListParams,
  options?: UsePrivateSizeSetsListOptions,
) => {
  const { workspaceId } = params;

  return useQuery({
    enabled: !!workspaceId && (options?.enabled ?? true),
    queryFn: !workspaceId
      ? skipToken
      : () => callAirApi<ListSizeSettingSetsResponse>(() => SizeSettings.Sets.list({ workspaceId })),
    queryKey: getPrivateSizeSetsListKey(params),
    staleTime: options?.staleTime,
  });
};
